// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2f-q";
export var animationRelative = "_2f-p";
export var backdropBlur = "_2f-0";
export var detailLabelCell = "_2f-12";
export var detailTable = "_2f-11";
export var detailValueCell = "_2f-13";
export var docIconBox = "_2f-1d";
export var docIconBoxMd = "_2f-1f";
export var docIconBoxSm = "_2f-1e";
export var docTypeRow = "_2f-16";
export var docTypeRowInner = "_2f-17";
export var dropdownMatchDatePicker = "_2f-3";
export var evidenceCardContent = "_2f-1c";
export var fileUploadSpin = "_2f-j";
export var gorgiasOpenButton = "_2f-15 _2f-d";
export var gorgiasTicketCard = "_2f-14";
export var heroModalFooterButton = "_2f-18";
export var hiddenContainer = "_2f-o";
export var iconPrimary = "_2f-1g";
export var iconQuaternary = "_2f-1i";
export var iconTertiary = "_2f-1h";
export var integrationCard = "_2f-1";
export var integrationLogoBox = "_2f-2";
export var mainColumnSticky = "_2f-1b";
export var maxWidthContainer = "_2f-19";
export var modalContentBody = "_2f-a";
export var modalHeaderImage = "_2f-5";
export var modalImageLabel = "_2f-7";
export var modalImageOverlay = "_2f-6";
export var modalImageSubtitle = "_2f-9";
export var modalImageTitle = "_2f-8";
export var modalImageWrapper = "_2f-4";
export var modalStickyFooter = "_2f-b";
export var removeButton = "_2f-e";
export var sidebarColumn = "_2f-1a";
export var spinner = "_2f-i";
export var timelineLine = "_2f-y";
export var timelineLineBlack = "_2f-10 _2f-y";
export var timelineLineGray = "_2f-z _2f-y";
export var timelineLineHeight = "_2f-x";
export var tlDotActivate = "_2f-u";
export var tlDotActivateAnim = "_2f-t";
export var tlDotHide = "_2f-s";
export var tlDotHideAnim = "_2f-r";
export var tlLineActivate = "_2f-w";
export var tlLineActivateAnim = "_2f-v";
export var uploadHint = "_2f-n";
export var uploadIconBox = "_2f-k";
export var uploadLabel = "_2f-m";
export var uploadText = "_2f-l";
export var uploadZone = "_2f-f";
export var uploadZoneCursorDefault = "_2f-h";
export var uploadZoneCursorPointer = "_2f-g";
export var uploadedFileRow = "_2f-c";
export var viewButton = "_2f-d";